import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { OrderProvider } from './context/OrderContext';
import { AllOrdersProvider } from './context/AllOrdersContext';
import { NotificationProvider } from './context/NotificationContext';
import MainApp from './MainApp';

const App: React.FC = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Initialisation simple de l'application
    setIsReady(true);
  }, []);

  if (!isReady) {
    return <div>Loading...</div>;
  }

  return (
    <BrowserRouter>
      <AuthProvider>
        <DataProvider>
          <OrderProvider>
            <NotificationProvider>
              <AllOrdersProvider>
                <MainApp />
              </AllOrdersProvider>
            </NotificationProvider>
          </OrderProvider>
        </DataProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;